import { useEffect } from 'react'
import { useNavigate, useMatches, useLocation } from 'react-router-dom'
import { faTimes, faList, faSlidersUp } from '@fortawesome/pro-light-svg-icons'
import { Button } from '@nazka/nazka.mapframe.components'

import './datapanel.styl'

function DataPanel({ children, isOpen, setIsOpen }) {
  const location = useLocation()
  const navigate = useNavigate()
  const matches = useMatches()

  const { name, actions = [] } = matches[matches.length - 1]?.handle || {}

  useEffect(() => {
    setIsOpen(true)
  }, [setIsOpen])

  return (
    <div className={`datapanel${isOpen ? '' : ' datapanel--closed'}`}>
      <div className="datapanel__header">
        <h2 className="datapanel__header__title">{name}</h2>
        <div className="datapanel__header__actions">
          { actions.includes('filter') && (
            <Button
              type="button"
              className="datapanel__header__actions__action"
              icon={/\/filter\/?$/.test(location.pathname) ? faList : faSlidersUp}
              layout="ghost"
              iconSize={/\/filter\/?$/.test(location.pathname) ? '22px' : '20px'}
              onClick={() => {
                const isOnFilter = /\/filter\/?$/.test(location.pathname)
                const nextPathname = isOnFilter
                  ? (location.pathname.replace(/\/filter\/?$/, '') || '/')
                  : `${location.pathname.replace(/\/+$/, '')}/filter`

                navigate({
                  pathname: nextPathname,
                  search: location.search,
                  hash: location.hash,
                })
              }}
            />
          )}
          { actions.includes('close') && (
            <Button
              onClick={() => {
                setIsOpen(false)
                setTimeout(() => navigate('/'), 300)
              }}
              className="datapanel__header__actions__action"
              icon={faTimes}
              iconSize="26px"
              layout="ghost"
            />
          )}
          { actions.includes('back') && (
            <Button
              onClick={() => {
                navigate(location.pathname.replace(/\/[^/]+$/, '') || '/')
              }}
              className="datapanel__header__actions__action"
              icon={faTimes}
              iconSize="28px"
              layout="ghost"
            />
          )}
        </div>
      </div>
      <div className="datapanel__content">
        {children}
      </div>
    </div>
  )
}

export default DataPanel
